import { StyledHeading } from './style'

const Heading = ({ children, className, as = 'h2', child, ...props }) => {
  return (
    <StyledHeading
      className={className}
      as={as}
      $child={child}
      {...props}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  )
}

export default Heading
